/** @jsxImportSource @emotion/react */
import { useMutation } from '@apollo/client';
import { InternetReminderFinal } from '@kompare/kompare-ui-library';
import { useState } from 'react';
import { useFunnelNavigate } from 'src/common/hooks/useFunnelNavigate.hook';
import { callMeSupplementary } from 'src/common/api/apollo/supplementary';
import config from 'src/config';

const CheckoutReminderFinalPage = () => {
  const navigate = useFunnelNavigate();
  const [openCallModal, setOpenCallModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const [showGeneralError, setShowGeneralError] = useState(false);

  const [callMeMutation] = useMutation(callMeSupplementary);

  const handleOpenModal = () => {
    setOpenCallModal(true);
    setShowThankYou(false);
    setShowGeneralError(false);
  };

  const handleCloseModal = () => {
    setOpenCallModal(false);
    setShowThankYou(false);
    setShowGeneralError(false);
    setPhoneNumber('');
    setIsPhoneValid(false);
  };

  const handlePhoneChange = (value: string, isValid: boolean) => {
    setPhoneNumber(value);
    setIsPhoneValid(isValid);
    setShowGeneralError(false);
  };

  const handleSend = async () => {
    if (!isPhoneValid) {
      setShowGeneralError(true);
      return;
    }

    setIsSending(true);
    setShowGeneralError(false);

    try {
      await callMeMutation({
        variables: {
          callMeInput: { product: 'dzo', number: phoneNumber },
        },
      });
      setShowThankYou(true);
    } catch {
      setShowGeneralError(true);
    } finally {
      setIsSending(false);
    }
  };

  const handleThankYouButtonClick = () => {
    handleCloseModal();
    if (config.REACT_APP_KOMPARE_HOME) {
      window.location.href = config.REACT_APP_KOMPARE_HOME;
    } else {
      navigate('/');
    }
  };

  return (
    <InternetReminderFinal
      openCallModal={openCallModal}
      onOpenModal={handleOpenModal}
      onCloseModal={handleCloseModal}
      phoneNumber={phoneNumber}
      onPhoneChange={handlePhoneChange}
      onSend={handleSend}
      isSending={isSending}
      showThankYou={showThankYou}
      showGeneralError={showGeneralError}
      onthankYouButtonClick={handleThankYouButtonClick}
    />
  );
};

export default CheckoutReminderFinalPage;
